export const LOADED = 'statics:loaded';

export function laoded(val: object) {
    return {
        type: LOADED,
        val
    };
}
